import React from "react";
import { Box, useTheme } from "@mui/material";

export interface AIGradientBoxProps {
  children: React.ReactNode;
  hideGradient?: boolean;
  fillContainer?: boolean;
}

export default function AIGradientBox(props: AIGradientBoxProps) {
  const theme = useTheme();

  let styles = {
    position: "relative",
    borderRadius: "10px",
    background: theme.colors.namedColors.aiGradient,
    backgroundSize: "400% 400%",
    animation: theme.colors.namedColors.aiAnimation,
    p: "2px",
    "@keyframes border-shimmer": {
      "0%": { backgroundPosition: "0% 0%" },
      "50%": { backgroundPosition: "100% 100%" },
      "100%": { backgroundPosition: "0% 0%" },
    }
  };

  let innerStyles = {
    position: "relative",
    background: theme.palette.background.paper,
    borderRadius: "8px",
    p: 2
  };

  const fixedContainer = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  };

  if (props.fillContainer) {
    styles = props.hideGradient ? {...fixedContainer} : { ...styles, ...fixedContainer };
    innerStyles = { ...innerStyles,
      position: "absolute",
      top: "2px",
      left: "2px",
      right: "2px",
      bottom: "2px",
      overflow: "auto"};
  }

  return (
    // Animated gradient border around the box
    <Box sx={styles}>
      <Box sx={innerStyles}>
      {props.children}
      </Box>
    </Box>
  );
}